import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, any } from "keautils";
import { validation, formfields } from "kea-react"
import { RxfyScalar } from "react-rxk";
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Observable } from "rxjs";


import { ContactosAutorizadosRx } from "./view";

export interface Props {
    guias: Observable<models.GuiaDTO[]>;
}

/**
* Muestra los contactos autorizados
*/
export class ContactosAutorizados extends React.PureComponent<Props> {
    guias = (props: Props) => props.guias;
    folios = createSelectorRx(this.guias, x => x.map(y => y.Folio));
    autorizados = createSelectorRx(this.folios, folios => observeResource(resources.Guia.ObtenerContactosAutorizados, folios));


    render() {
        const guias = this.guias(this.props);
        const autorizados = this.autorizados(this.props);
        return <ContactosAutorizadosRx guias={guias} autorizados={autorizados} />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/autorizados/index.tsx